import {
  Box,
  Button,
  HeadingText,
  ImageMessage,
  ParagraphText,
  StackLayout,
  useMediaQuery,
  queryHelpers,
} from "@leagueplatform/genesis-core";
import { useIntl } from "@leagueplatform/locales";
import highlightsIcon from "assets/highlights.svg";
import { useSetPostFtux } from "hooks/mutations/use-set-post-ftux.hook";

type GetStartedStepProps = {
  onContinue: () => void;
  onError: () => void;
};

export const GetStartedStep = ({
  onContinue,
  onError,
}: GetStartedStepProps) => {
  const { formatMessage } = useIntl();
  const isMobile = useMediaQuery(queryHelpers.down("tablet"));
  const { mutateAsync: setPostFtux, isLoading } = useSetPostFtux();

  const handleStart = async () => {
    try {
      await setPostFtux();
      onContinue();
    } catch {
      onError();
    }
  };

  return (
    <StackLayout
      horizontalAlignment="center"
      css={{
        width: "100%",
        minHeight: isMobile ? "100dvh" : "auto",
        background: "$surfaceBackgroundPrimary",
      }}
    >
      <ImageMessage
        image={highlightsIcon}
        imageGap="$twoAndHalf"
        css={{
          padding: isMobile ? "$oneAndHalf" : "$twoAndHalf",
          maxWidth: isMobile ? "100%" : "none",
          flexGrow: isMobile ? 1 : 0,
        }}
      >
        <HeadingText
          level="2"
          size="xl"
          css={{ textAlign: "center", marginBlockEnd: "$half" }}
        >
          {formatMessage({ id: "STR_ACCOUNT_SETUP_LETS_GET_STARTED" })}
        </HeadingText>
        <ParagraphText
          emphasis="subtle"
          css={{ "&&": { textAlign: "center" } }}
        >
          {formatMessage({ id: "STR_ACCOUNT_SETUP_HIGHLIGHTS_BODY" })}
        </ParagraphText>
      </ImageMessage>
      {isMobile ? (
        <StackLayout
          css={{
            width: "100%",
            flexGrow: 0,
            flexShrink: 0,
            marginBlockStart: "auto",
            borderTop: "1px solid $onSurfaceBorderSubdued",
            background: "$surfaceBackgroundSecondary",
            padding: "$one $oneAndHalf",
          }}
        >
          <Button
            onClick={handleStart}
            loading={isLoading}
            width="fillContainer"
          >
            {formatMessage({ id: "STR_ACCOUNT_SETUP_LETS_GO" })}
          </Button>
        </StackLayout>
      ) : (
        <Box
          css={{
            width: "100%",
            maxWidth: "560px",
            paddingInline: "$twoAndHalf",
            paddingBlockEnd: "$twoAndHalf",
          }}
        >
          <Button
            onClick={handleStart}
            loading={isLoading}
            width="fillContainer"
          >
            {formatMessage({ id: "STR_ACCOUNT_SETUP_LETS_GO" })}
          </Button>
        </Box>
      )}
    </StackLayout>
  );
};
